import { Banner } from '../lib/UiKitBannerHero';

interface EventSetBannerHero {
  mode: Banner['mode'] | 'off';
}

export const EVENT_SET_BANNER_HERO = 'set-banner-hero';

export const eventBannerHero = {
  setMode: (mode: EventSetBannerHero['mode'] = 'off') => {
    window.dispatchEvent(
      new CustomEvent<EventSetBannerHero>(EVENT_SET_BANNER_HERO, {
        detail: { mode }
      })
    );
  },

  onModeChange: (callback: (mode: EventSetBannerHero['mode']) => void) => {
    const handler = (e: CustomEvent<EventSetBannerHero>) => {
      callback(e.detail.mode);
    };

    window.addEventListener(EVENT_SET_BANNER_HERO, handler as EventListener);
    return () => {
      window.removeEventListener(
        EVENT_SET_BANNER_HERO,
        handler as EventListener
      );
    };
  }
};
